import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap, retry } from 'rxjs/operators';
import 'rxjs/add/observable/throw';

@Injectable()
export class DropdownService {
  url = '';

  constructor(private _http: HttpClient,
    @Inject('BASE_URL') baseUrl: string) {
    this.url = baseUrl + 'api/dropdown/';
  }

  private handleError(operation: String) {
    return (err: any) => {
      let errMsg = `error in ${operation}() retrieving ${this.url}`;
      console.log(`${errMsg}:`, err);
      if (err instanceof HttpErrorResponse) {
        // you could extract more info about the error if you want, e.g.:
        console.log(`status: ${err.status}, ${err.statusText}`);
        // errMsg = ...
      }
      return Observable.throw(err);
    }
  }

  public getDDStates(): Observable<IddStates[]> {
    return this._http.get<IddStates[]>(this.url + 'states')
      .pipe(retry(2),
        tap(data => console.log('states data:', data)),
        catchError(this.handleError('getDDStates'))
      );
  }

  public getDDIndustries(): Observable<IIndustry[]> {
    return this._http.get<IIndustry[]>(this.url + 'industries')
      .pipe(retry(2),
        tap(data => console.log('industry data:', data)),
        catchError(this.handleError('getDDIndustry'))
      );
  }

  public getDDTimings(): Observable<ITiming[]> {
    return this._http.get<ITiming[]>(this.url + 'timings')
      .pipe(retry(2),
        tap(data => console.log('timings data:', data)),
        catchError(this.handleError('getDDTimings'))
      );
  }

  public getDDStatus(): Observable<IStatus[]> {
    return this._http.get<IStatus[]>(this.url + 'status')
      .pipe(retry(2),
        tap(data => console.log('status data:', data)),
        catchError(this.handleError('getDDStatus'))
      );
  }

  public getDDLeadType(): Observable<ILeadType[]> {
    return this._http.get<ILeadType[]>(this.url + 'leadTypes')
      .pipe(retry(2),
        tap(data => console.log('leadType data:', data)),
        catchError(this.handleError('getDDLeadType'))
      );
  }

  public getDDEmployees(): Observable<IEmployee[]> {
    return this._http.get<IEmployee[]>(this.url + 'employees')
      .pipe(retry(2),
        tap(data => console.log('employees data:', data)),
        catchError(this.handleError('getDDEmployees'))
      );
  }

}
